import React from 'react';

const FirstPage: React.FC = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.5"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
		role="presentation"
	>
		<path d="M5 6V18" />
		<path d="M15 18L9 12L15 6" />
	</svg>
);

export default FirstPage;
